module.exports = __webpack_public_path__ + "static/media/notifications-icon.66a23686.svg";